/**
 * Migrates legacy day-based task estimates into `estimatedDurationMinutes`
 * and strips the old field. Used for API payloads, clipboard import, and sprint load.
 */

const LEGACY_DAYS_KEY = 'estimatedDays';

function estimatedMinutesFromLegacyShape(source) {
  if (!source) return null;
  const m = source.estimatedDurationMinutes;
  if (m != null && Number.isFinite(m) && m > 0) {
    return Math.round(m);
  }
  const legacyDays = source[LEGACY_DAYS_KEY];
  if (legacyDays != null && legacyDays > 0) {
    return Math.round(legacyDays * 1440);
  }
  return null;
}

/** For clipboard / paste: same precedence as normalize, without mutating. */
export function syncEstimatedMinutesFromClipboardPayload(source) {
  return estimatedMinutesFromLegacyShape(source);
}

/**
 * @param {Object} task
 * @returns {Object}
 */
export function normalizeTaskEstimatedDuration(task) {
  const minutes = estimatedMinutesFromLegacyShape(task);
  const hadLegacy = Object.prototype.hasOwnProperty.call(task, LEGACY_DAYS_KEY);
  if (!hadLegacy && task.estimatedDurationMinutes === minutes) {
    return task;
  }

  const { [LEGACY_DAYS_KEY]: _legacy, ...rest } = task;
  return { ...rest, estimatedDurationMinutes: minutes };
}

/**
 * @param {Object} sprint
 * @returns {{ sprint: Object, migrated: boolean }}
 */
export function migrateSprintEstimatedDuration(sprint) {
  if (!sprint?.tasks?.length) {
    return { sprint, migrated: false };
  }
  let changed = false;
  const nextTasks = sprint.tasks.map((t) => {
    const n = normalizeTaskEstimatedDuration(t);
    if (n !== t) changed = true;
    return n;
  });
  if (!changed) return { sprint, migrated: false };
  return {
    sprint: { ...sprint, tasks: nextTasks },
    migrated: true,
  };
}
